export const packageList = [
  {
    name: 'bigdata',
    activeRule: ['kyact'],
  },
  {
    name: 'kyetree',
    activeRule: ['kyetree'],
  },
]

export const remoteModuleConfig = {
  dev: ['bigdata', 'kyetree'],
  stg: ['bigdata', 'kyetree'],
  uat: ['bigdata', 'kyetree'],
  prd: ['bigdata', 'kyetree'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/bigdata/index.js